export enum TrusteeLink {
  EMPLOYEE = 'EMPLOYEE',
  SHAREHOLDER = 'SHAREHOLDER',
  KEY_PERSON = 'KEY_PERSON',
  PARTNER = 'PARTNER',
  FATHER = 'FATHER',
  MOTHER = 'MOTHER',
  SISTER = 'SISTER',
  BROTHER = 'BROTHER',
}
